import { useRef } from 'react';

import { Box } from '@/components/Box';
import { Icon } from '@/components/Icon';

import * as S from './Accordion.styles';

export interface AccordionProps {
  children: React.ReactNode;
  className?: string;
  isOpen: boolean;
  onClick: () => void;
  title: React.ReactNode;
}

export const Accordion = ({
  children,
  className,
  isOpen,
  onClick,
  title,
}: AccordionProps) => {
  const contentRef = useRef<HTMLDivElement>(null);
  const id = title?.toString().replace(/\s+/g, '');

  return (
    <S.Wrapper className={className} data-testid='AccordionWrapper'>
      <S.Header data-testid='AccordionHeader'>
        <S.HeaderContent
          aria-controls={id}
          aria-expanded={isOpen}
          data-testid='AccordionHeaderContent'
          forwardedAs='button'
          isOpen={isOpen}
          onClick={onClick}
          px='s125'
        >
          {title}
          <Icon
            className='accordion-header-icon'
            name={isOpen ? 'chevronUp' : 'chevronDown'}
            variant='regular'
          />
        </S.HeaderContent>
      </S.Header>
      <S.Content
        ref={contentRef}
        contentHeight={contentRef?.current?.scrollHeight || 0}
        data-testid='AccordionContent'
        id={id}
        isOpen={isOpen}
      >
        <Box className='AccordionBox'>{children}</Box>
      </S.Content>
    </S.Wrapper>
  );
};

Accordion.displayName = 'Accordion';
